/* Pump Club — Back-in-stock "Notify Me" modal handler.
   Populates product context when the modal opens and submits the
   capture form (email + WhatsApp/phone) to Shopify's contact endpoint via AJAX. */
(function () {
  function init() {
    var modalEl = document.getElementById('pcNotifyModal');
    if (!modalEl) return;

    var productLine = modalEl.querySelector('.pc-notify-product');
    var prodInput = modalEl.querySelector('.pc-notify-product-input');
    var urlInput = modalEl.querySelector('.pc-notify-url-input');
    var form = modalEl.querySelector('.pc-notify-form');
    var success = modalEl.querySelector('.pc-notify-success');
    var error = modalEl.querySelector('.pc-notify-error');

    // Fill product context from the button that opened the modal.
    modalEl.addEventListener('show.bs.modal', function (e) {
      var btn = e.relatedTarget;
      var title = btn ? btn.getAttribute('data-product-title') : '';
      var url = btn ? btn.getAttribute('data-product-url') : '';
      if (productLine) productLine.textContent = title ? ('“' + title + '”') : '';
      if (prodInput) prodInput.value = title || '';
      if (urlInput) urlInput.value = url ? (location.origin + url) : location.href;
      if (form) form.hidden = false;
      if (success) success.hidden = true;
      if (error) error.hidden = true;
    });

    if (!form) return;
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var submitBtn = form.querySelector('.pc-notify-submit');
      var label = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }
      if (error) error.hidden = true;

      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' }
      }).then(function (r) {
        if (!(r.ok || r.status === 0 || r.status === 302)) throw new Error('bad status');
        if (form) form.hidden = true;
        if (success) success.hidden = false;
      }).catch(function () {
        if (error) error.hidden = false;
      }).finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = label || 'Notify me'; }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
